export const DEMO_TICKET_STATUS = [
  {
    id: '',
    name: 'Tất cả trạng thái',
  },
  {
    id: 0,
    name: 'Bật',
  },
  {
    id: 1,
    name: 'Tắt',
  },
];

export function getTicketStatus(status) {
  const ticketStatus = DEMO_TICKET_STATUS.find((item) => item.id === status);
  return ticketStatus ? ticketStatus.name : 'Unknown';
}

// Trạng thái đồng bộ CRM (outbound ERP -> CRM). Khớp enum BE CRM_OUTBOUND_SYNC_STATUS.
export const DEMO_TICKET_CRM_SYNC_STATUS = {
  PENDING: 0,
  SYNCED: 1,
  FAILED: 2,
};

const CRM_SYNC_META = {
  [DEMO_TICKET_CRM_SYNC_STATUS.PENDING]: {
    key: 'pending',
    label: 'Chờ đồng bộ',
    icon: 'fas fa-clock',
  },
  [DEMO_TICKET_CRM_SYNC_STATUS.SYNCED]: {
    key: 'synced',
    label: 'Đã đồng bộ',
    icon: 'fas fa-check-circle',
  },
  [DEMO_TICKET_CRM_SYNC_STATUS.FAILED]: {
    key: 'failed',
    label: 'Lỗi đồng bộ',
    icon: 'fas fa-exclamation-circle',
  },
};

const CRM_SYNC_NONE_META = {
  key: 'none',
  label: 'Chưa đồng bộ',
  icon: 'fas fa-minus-circle',
};

/**
 * Trả về meta (key/label/icon) cho trạng thái đồng bộ CRM của phiếu xe demo.
 * status === null/undefined => phiếu cũ chưa từng đồng bộ.
 * @param {number|null|undefined} status
 */
export function getCrmSyncStatusMeta(status) {
  if (status === null || status === undefined) {
    return CRM_SYNC_NONE_META;
  }
  return CRM_SYNC_META[status] || CRM_SYNC_NONE_META;
}
